<script lang="ts">
    import {Image} from "sveltestrap";
    import type {OrganizationInfo} from "../helpers/orgTypes";

    export let orgInfo: OrganizationInfo;
</script>

<Image src={orgInfo.avatar} thumbnail
       style="background-color: #1e4f9e;margin-right: 0.3em;border-radius: 50%;height: 30px;width: 30px"/>
{orgInfo.name}